import { useEffect } from 'react';
import { units } from '@ui/css';
import { throttleToAnimationFrame } from '@utils/common';
import { combineTokens, makeScaleableToken, applyCssDeclarations } from '@utils/css';

const root = combineTokens("--root", {
  paddingLeft: [units.px(55), makeScaleableToken],
  paddingRight: [units.px(55), makeScaleableToken]
});
const textColumn = combineTokens("--text-column", {
  width: units.px(700)
});
const element = combineTokens("--element", {
  offsetLeft: [units.px(0), makeScaleableToken],
  offsetRight: [units.px(0), makeScaleableToken]
});
const container = combineTokens("--container", {
  width: [units.vw(100), makeScaleableToken],
  height: [units.vh(100), makeScaleableToken],
  offsetLeft: [units.px(0), makeScaleableToken],
  offsetRight: [units.px(0), makeScaleableToken]
});
function useContentEngineBoundaryProps(ref, args) {
  useEffect(() => {
    let lastObservedWidth = void 0;
    const updateBoundaryProps = () => {
      if (!ref.current) {
        return;
      }
      const bbox = ref.current.getBoundingClientRect();
      applyCssDeclarations(
        container.__override({
          offsetLeft: `${bbox.left}px`,
          offsetRight: `${document.documentElement.clientWidth - bbox.right}px`,
          width: `${bbox.width}px`
        }),
        ref
      );
      lastObservedWidth = bbox.width;
    };
    updateBoundaryProps();
    const handleResize = throttleToAnimationFrame(() => updateBoundaryProps());
    const observer = new ResizeObserver(([entry]) => {
      if (lastObservedWidth !== (entry == null ? void 0 : entry.contentRect.width)) {
        handleResize();
      }
    });
    if (ref.current) {
      observer.observe(
        (args == null ? void 0 : args.observerTarget) === "self" ? ref.current : ref.current.parentElement ?? ref.current
      );
    }
    window.addEventListener("resize", handleResize);
    return () => {
      observer.disconnect();
      window.removeEventListener("resize", handleResize);
    };
  }, [args == null ? void 0 : args.observerTarget, ref]);
}

export { container, element, root, textColumn, useContentEngineBoundaryProps };
//# sourceMappingURL=boundary.js.map
